import { render, staticRenderFns } from "./RedeemVoucher.vue?vue&type=template&id=47385845&scoped=true&"
import script from "./RedeemVoucher.vue?vue&type=script&lang=ts&"
export * from "./RedeemVoucher.vue?vue&type=script&lang=ts&"
import style0 from "./RedeemVoucher.vue?vue&type=style&index=0&id=47385845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47385845",
  null
  
)

export default component.exports